import React from "react";

interface IErrorIconProps {
  hidden?: boolean;
  className?: string;
}

const ErrorIcon = ({ hidden = false, className = "" }: IErrorIconProps) => {
  const color = hidden ? 'white' : '#EC0000';

  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      className={className}
    >
      <rect
        x="0.780273"
        width="14"
        height="14"
        rx="7"
        fill="white"
        stroke={color}
        strokeWidth="1"
      />
      <path d="M7.78027 2V8" stroke={color} strokeWidth="1" />
      <circle cx="7.78027" cy="10.5" r="0.5" fill={color} stroke={color} />
    </svg>
  );
};

export default ErrorIcon;
